'use client';

import HubSpotLegacyForm from './HubSpotLegacyForm';
import HubSpotStandardForm from './HubSpotStandardForm';
import { IHubSpotForm } from './types';
import { extractHubSpotFormData } from '@/utils/helpers';

export default function HubSpotForm(props: IHubSpotForm) {
  const { embedCode } = props;
  const { isLegacy } = extractHubSpotFormData(embedCode);

  if (!embedCode) {
    return null;
  }

  return isLegacy ? (
    <HubSpotLegacyForm {...props} />
  ) : (
    <HubSpotStandardForm {...props} />
  );
}
